import React, { useState } from 'react';
import ComparisonWidgetItem from '@components-clean/core/widgets/comparison-widget-item';
import RagChangeWidgetItem from '@components-clean/core/widgets/ragChange-widget-item';
import WidgetItem from '@components-clean/core/widgets/studyDashboard-widget-item';
import { WidgetIcon } from '@interfaces/widget.interface';
import WidgetConfig from '@pages-clean/admin/study/manage-hubs/central-monitoring/widget-config';
import { ComparisonWidgetDataProps } from '@pages-clean/admin/study/manage-hubs/central-monitoring/widget-config/comparison-widget-config.interface';
import { RagWidgetDataProps } from '@pages-clean/admin/study/manage-hubs/central-monitoring/widget-config/ragChange-widget-config.interface';
import { WidgetDataProps } from '@pages-clean/admin/study/manage-hubs/central-monitoring/widget-config/widget-config.interface';
import Card from 'views-clean/components/core/card';

interface WidgetPageProps {
    isDisabled: boolean;
}

const widgetsDataArray = [
    {
        id: 0,
        iconName: 1,
        displayName: '283',
        typeCode: 1,
        tableCode: 1,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
    },
    {
        id: 1,
        iconName: 2,
        displayName: '163',
        typeCode: 2,
        tableCode: 2,
        fieldName: 'fieldTwo',
        displayIndex: 1,
        fieldKey: 'Testing',
    },
    {
        id: 2,
        iconName: 3,
        displayName: 'An Item Name',
        typeCode: 3,
        tableCode: 3,
        fieldName: 'fieldThree',
        displayIndex: 2,

        fieldKey: "I'm adding a really long title to test this out we are pushing this past the legal limit",
    },
    {
        id: 3,
        iconName: 4,
        displayName: '8960.7896345',
        typeCode: 4,
        tableCode: 4,
        fieldName: 'fieldFour',
        displayIndex: 3,
        fieldKey: 'Short',
    },
    {
        id: 4,
        iconName: 5,
        displayName: 'This Is A Really Long Title To Test What Happens LLAAAAAAAAAAAAAAAAAAAA',
        typeCode: 5,
        tableCode: 5,
        fieldName: 'fieldFive',
        displayIndex: 4,
        fieldKey: 'Last one',
    },
];

const ragChangeWidgetsDataArray = [
    {
        id: 0,
        iconName: 1,
        typeCode: 1,
        tableCode: 1,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
        ragScore: 50,
        comparisonRagScore: 50,
        comparisonDatasetSelected: true,
    },
    {
        id: 1,
        iconName: 2,
        typeCode: 2,
        tableCode: 2,
        fieldName: 'fieldTwo',
        displayIndex: 1,
        fieldKey: 'Testing',
        ragScore: 76.54,
        comparisonRagScore: 60.25,
        comparisonDatasetSelected: true,
    },
    {
        id: 2,
        iconName: 3,
        typeCode: 3,
        tableCode: 3,
        fieldName: 'fieldThree',
        displayIndex: 2,
        fieldKey: "I'm adding a really long title to test this out we are pushing this past the legal limit",
        ragScore: 66.23,
        comparisonRagScore: 84.54,
        comparisonDatasetSelected: true,
    },
    {
        id: 3,
        iconName: 4,
        typeCode: 4,
        tableCode: 4,
        fieldName: 'fieldFour',
        displayIndex: 3,
        fieldKey: 'Short',
        ragScore: 100,
        comparisonRagScore: 12.33,
        comparisonDatasetSelected: true,
    },
    {
        id: 4,
        iconName: 5,
        typeCode: 5,
        tableCode: 5,
        fieldName: 'fieldFive',
        displayIndex: 4,
        fieldKey: 'No comparison dataset selected',
        ragScore: 33.65,
        comparisonRagScore: null,
        comparisonDatasetSelected: false,
    },
    {
        id: 5,
        iconName: 5,
        typeCode: 5,
        tableCode: 5,
        fieldName: 'fieldFive',
        displayIndex: 4,
        fieldKey: 'Comparison dataset has no value',
        ragScore: 46,
        comparisonRagScore: null,
        comparisonDatasetSelected: true,
    },
    {
        id: 6,
        iconName: 5,
        typeCode: 5,
        tableCode: 5,
        fieldName: 'fieldFive',
        displayIndex: 4,
        fieldKey: 'Dataset in focus has no value',
        ragScore: null,
        comparisonRagScore: 44.5,
        comparisonDatasetSelected: true,
    },
];

const comparisonWidgetsDataArray = [
    {
        id: 0,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
        datasetInFocusScore: 50,
        comparisonDatasetScore: 50,
        comparisonDatasetSelected: true,
        change: 0,
    },
    {
        id: 1,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
        datasetInFocusScore: 75,
        comparisonDatasetScore: 50,
        comparisonDatasetSelected: true,
        change: 25,
    },
    {
        id: 2,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
        datasetInFocusScore: 25,
        comparisonDatasetScore: 50,
        comparisonDatasetSelected: true,
        change: 25,
    },
    {
        id: 3,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
        datasetInFocusScore: 50.888,
        comparisonDatasetScore: 50,
        comparisonDatasetSelected: true,
        change: 0.888,
    },
    {
        id: 4,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
        datasetInFocusScore: 45.67,
        comparisonDatasetScore: 50,
        comparisonDatasetSelected: true,
        change: 4.33,
    },
    {
        id: 5,
        fieldName: 'fieldOne',
        displayIndex: 0,
        fieldKey: 'Subjects on Site',
        datasetInFocusScore: 1000.5001,
        comparisonDatasetScore: 50,
        comparisonDatasetSelected: true,
        change: 950.5001,
    },
    {
        id: 6,
        fieldName: 'fieldFive',
        displayIndex: 4,
        fieldKey: 'No comparison dataset selected',
        datasetInFocusScore: 33.65,
        comparisonDatasetScore: null,
        comparisonDatasetSelected: false,
    },
    {
        id: 7,
        fieldName: 'fieldFive',
        displayIndex: 4,
        fieldKey: 'Comparison dataset has no value',
        datasetInFocusScore: 46,
        comparisonDatasetScore: null,
        comparisonDatasetSelected: true,
    },
    {
        id: 6,
        fieldName: 'fieldFive',
        displayIndex: 4,
        fieldKey: 'Dataset in focus has no value',
        datasetInFocusScore: null,
        comparisonDatasetScore: 44.5,
        comparisonDatasetSelected: true,
    },
];

const WidgetPage = ({ isDisabled }: WidgetPageProps) => {
    const [widgetConfigData, setWidgetConfigData] = useState<WidgetDataProps[]>(widgetsDataArray as WidgetDataProps[]);

    const ragChangeWidgetConfigData = ragChangeWidgetsDataArray as RagWidgetDataProps[];

    const comparisonWidgetConfigData = comparisonWidgetsDataArray as ComparisonWidgetDataProps[];

    const mutation = (saveData: WidgetDataProps[]) => {
        return new Promise((resolve, reject) => {
            if (saveData) {
                setWidgetConfigData([...saveData]);
                resolve([...saveData]);
            } else {
                reject();
            }
        });
    };

    return (
        <>
            <Card data-testid="widget-container-1" title="Field Widgets" className="k-mb-5">
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {widgetConfigData.map((widget) => (
                        <WidgetItem
                            title={widget.fieldKey}
                            subtitle={widget.displayName}
                            isDraggable={isDisabled}
                            icon={widget.iconName as WidgetIcon}
                            onClose={() => {}}
                            data-testid={`widget-${widget.id}`}
                        />
                    ))}
                </div>
            </Card>
            <WidgetConfig
                data={widgetConfigData}
                mutation={mutation as (data: WidgetDataProps[]) => Promise<void>}
                canEdit
                setChangesFlag={() => false}
            />

            <Card
                data-testid="widget-container-2"
                title="RAG Change Widgets"
                className="k-mb-5"
                style={{ marginTop: '20px' }}
            >
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {ragChangeWidgetConfigData.map((widget) => (
                        <RagChangeWidgetItem
                            title={widget.fieldKey}
                            isDraggable={isDisabled}
                            onClose={() => {}}
                            data-testid={`widget-${widget.id}`}
                            ragScore={widget.ragScore}
                            comparisonRagScore={widget.comparisonRagScore}
                            comparisonDatasetSelected={widget.comparisonDatasetSelected}
                        />
                    ))}
                </div>
            </Card>

            <Card data-testid="widget-container-3" title="Comparison Widgets" className="k-mb-5">
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {comparisonWidgetConfigData.map((widget) => (
                        <ComparisonWidgetItem
                            title={widget.fieldKey}
                            isDraggable={isDisabled}
                            onClose={() => {}}
                            data-testid={`widget-${widget.id}`}
                            datasetInFocusScore={widget.datasetInFocusScore}
                            comparisonDatasetScore={widget.comparisonDatasetScore}
                            comparisonDatasetSelected={widget.comparisonDatasetSelected}
                            change={widget.change}
                        />
                    ))}
                </div>
            </Card>
        </>
    );
};

export default WidgetPage;
